
import { Typography, Paper, createStyles, makeStyles, Theme, Grid } from "@material-ui/core";
import AppInitSingletonBo from "../../../consumer/init/AppInitSingletonBo";
import TransitionSlide from "../../transition/TransitionSlide";
import useAgenturKontakt from "./useAgenturKontakt";
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';

const useStyles = makeStyles((theme: Theme) => createStyles({

    overlay: {
        display: 'block',
        position: 'fixed',
        zIndex: theme.zIndex.modal,
        top: 120,
        left: 0,
        width: '100%',
        height: '100%',

    }
}));

const AgenturKontakt: React.FC = () => {
    const classes = useStyles();
    const { changeVisibleState, renderMainKontakt } = useAgenturKontakt();
    const agtName1 = AppInitSingletonBo.vermittler?.agtName1;
    const agtTelefon = AppInitSingletonBo.vermittler?.agtTelefon;

    return (
        <TransitionSlide show={renderMainKontakt} className={classes.overlay}>
            <Grid container onClick={changeVisibleState} style={{maxWidth: 670, marginLeft: 'auto', marginRight: 'auto'}}>
                <Grid item xs={1} sm={1} md={1} lg={1} />

                <Grid item xs={10} sm={10} md={10} lg={10} style={{ textAlign: 'center', marginTop: 230 }}>
                    <Paper style={{ padding: 20 }}>

                        <Typography color='textPrimary' variant='h1'>Können wir Ihnen helfen?</Typography>
                        <Typography color='textPrimary' variant='body2'>Melden Sie sich gerne bei uns:</Typography>

                        {agtName1 && <Typography color='textPrimary' variant='subtitle2' style={{ marginTop: 10, fontSize: 16 }}>{agtName1}</Typography>}

                        {agtTelefon &&
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <PhoneOutlinedIcon color='primary' />
                                <Typography variant='body1' color='textPrimary' style={{ marginLeft: 10 }}>{agtTelefon}</Typography>
                            </div>
                        }

                    </Paper>
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1} />
            </Grid>
        </TransitionSlide>
    );
}

export default AgenturKontakt;